import moment from 'moment';

const DATE_YEAR_STR_FORMAT = 'YYYY';
const DATE_YEAR_FORMAT = 'YYYY年';
const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
const DATE_TIME_FORMAT_ZH = 'YYYY年MM月DD日 HH:mm';
const DATE_FORMAT = 'YYYY-MM-DD';
const DATE_FORMAT_ZH = 'YYYY年MM月DD日';
const DATE_FORMAT_MONTH_ZH = 'YYYY年MM月';

export function formatToDateTimeZH(date) {
  return moment(date).format(DATE_TIME_FORMAT_ZH);
}

export function formatToMonthZH(date) {
  return moment(date).format(DATE_FORMAT_MONTH_ZH);
}

export function formatToDateZH(date) {
  return moment(date).format(DATE_FORMAT_ZH);
}

export function formatToDateTime(date) {
  return moment(date).format(DATE_TIME_FORMAT);
}

export function formatToDate(date) {
  return moment(date).format(DATE_FORMAT);
}
export function formatToYear(date) {
  return moment(date).format(DATE_YEAR_FORMAT);
}
export function formatToYearStr(date) {
  return moment(date).format(DATE_YEAR_STR_FORMAT);
}

export const formatAgo = (str) => {
  if (!str) return '';
  const date = new Date(Number(str));
  const time = new Date().getTime() - date.getTime(); // 现在的时间-传入的时间 = 相差的时间（单位 = 毫秒）
  if (time < 0) {
    return '';
  } else if (time / 1000 < 30) {
    return '刚刚';
  } else if (time / 1000 < 60) {
    return parseInt(String(time / 1000)) + '秒前';
  } else if (time / 60000 < 60) {
    return parseInt(String(time / 60000)) + '分钟前';
  } else if (time / 3600000 < 24) {
    return parseInt(String(time / 3600000)) + '小时前';
  } else if (time / 86400000 < 31) {
    return parseInt(String(time / 86400000)) + '天前';
  } else if (time / 2592000000 < 12) {
    return parseInt(String(time / 2592000000)) + '月前';
  } else {
    return parseInt(String(time / 31536000000)) + '年前';
  }
};

export const dateUtil = moment;
